/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { FADE_IN_ANIMATION_SHORT } from '../../../styles/animations';
import { LAYER } from '../../../layout/zIndex';
import { WHITE } from '../../../styles/colors';
import { Loader } from './Loader';


const Background = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  ${FADE_IN_ANIMATION_SHORT};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${LAYER.TWO.BLOCKING_LOADER};
`;

const BlockingLoaderContainer = css`
  border-radius: 100%;
  background-color: ${WHITE};
  transition: all .5s ease;
  padding: 20px;
`;

/**
 * BlockingLoader: a component that
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class BlockingLoader extends React.PureComponent<{
  bgCss?: SerializedStyles;
  rootCss?: SerializedStyles;
}> {
  public render = () => (
    <Background css={this.props.bgCss}>
      <div css={BlockingLoaderContainer}>
        <Loader rootCss={css`
                  width: 100px;
                  height: 100px;
                  ${this.props.rootCss}
                `}/>
      </div>
    </Background>
  );
}
